<script setup lang="ts">
// types
import type { StrapiHeader } from '@ts-strapi/interfaces'
// components
import HeaderDesktop from '@Widgets/Headers/HeaderDesktop.vue'
import HeaderMobile from '@Widgets/Headers/HeaderMobile.vue'

defineOptions({
  name: 'HeaderRoot',
})

defineProps<{
  data: StrapiHeader
}>()

</script>

<template>
  <HeaderMobile :data="data" />
  <HeaderDesktop :data="data" />
</template>
